import domReady from '@wordpress/dom-ready';

domReady(function() {
  document.querySelectorAll('.js-select-linker').forEach((el) => {
    console.log("Adding in the event listener!")
    el.addEventListener('change', selectLinker);
  });
});

/**
 * Loads a url referenced in a select option.
 *
 * @param {Object} event - the event object
 */
function selectLinker(event) {
  console.log("select linker event fired!!!");
  if (event.currentTarget.value) {
    console.log("event.currentTarget.value: "+event.currentTarget.value);
    window.location.href = event.currentTarget.value;
  }
}